// @flow

export const FacebaseNode = `
  id
  name
  uuid
  personLimit
  model
  online
`;

export const UserNode = `
  id
  fullName
  cognitoUuid
  defaultFacebase {
    id
    name
    uuid
  }
`;

export const UserAdminNode = `
  firstName
  lastName
  auditCreationDate
  auditCreatedBy
  lastUpdatedBy
  lastUpdatedDate
  lastLoggedIn
  company {
    id
    uuid
    name
  }
`;

export const LicenceAdminNode = `
  auditCreatedBy
  auditCreationDate
  lastUpdatedBy
  lastUpdatedDate
  company {
    id
    name
    uuid
    companyType
    licenceLimit
  }
`;

export const LicenceBaseNode = `
  id
  uuid
  autoAssign
  startDate
  expiryDate
  licenceType
  noOfStreams
  poFile
  maintenanceExpiryDate
`;

export const LicenceModuleNode = `
  modules {
    name
    version
    data
  }
`;

export const LicenceNode = `
  ${LicenceBaseNode}
  authorisedReseller
  deviceLimit
  devices: usedSlots {
    edges {
      node {
        id
        hostId
        lastUpdatedBy
      }
    }
  }
  facebase {
    id
    name
    uuid
    personLimit
  }
  ${LicenceModuleNode}
  licenceExtents{
    edges{
      node{
        ${LicenceBaseNode}
        ${LicenceModuleNode}
        noOfSlots
        auditCreatedBy
        auditCreationDate
        auditDeletedBy
        auditDeletedDate
      }
    }
  }
`;

export const CompanyInfoNode = `
  id
  name
  uuid
  contactName
  contactNumber
  contactEmail
  postcode
  notes
  abn
  authorisedReseller
  companyType
  address
  suburb
  city
  state
  country
`;

export const CompanySpecialNode = `
licenceLimit
`;

export const CompanyNode = `
  ${CompanyInfoNode}
  ${CompanySpecialNode}
  facebases {
    edges {
      node {
        ${FacebaseNode}
      }
    }
  }
  licences {
    edges {
      node {
        ${LicenceNode}
      }
    }
  }
  children {
    edges {
      node {
        ${CompanyInfoNode}
        licences {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
  users {
    edges {
      node {
        ${UserNode}
      }
    }
  }
`;

export const CompanyAdminInfoNode = `
  auditCreatedBy
  auditCreationDate
  lastUpdatedBy
  lastUpdatedDate
  groupName
  specialType
  parent {
    id
    name
    uuid
    authorisedReseller
    companyType
  }
  tier {
    id
    name
  }
  productSheet{
    id
    uuid
    description
  }
`;

export const CompanyAdminNode = `
  ${CompanyInfoNode}
  ${CompanySpecialNode}
  ${CompanyAdminInfoNode}
  facebases {
    edges {
      node {
        ${FacebaseNode}
      }
    }
  }
  licences {
    edges {
      node {
        ${LicenceNode}
        ${LicenceAdminNode}
      }
    }
  }
  children {
    edges {
      node {
        ${CompanyInfoNode}
        licences {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
  users {
    edges {
      node {
        ${UserNode}
      }
    }
  }
`;

export const CompanyFacebaseNode = `
  id
  name
  uuid
  facebases {
    edges {
      node {
        ${FacebaseNode}
      }
    }
  }
`;

export const PriceRangeNode = `
  priceRanges {
    edges {
      node {
        id
        minimumQuantity
        price
      }
    }
  }
`;

export const PartNode = `
  id
  partNo
  description
  notes
  priceType
  basePrice
  minimumQuantity
  maximumQuantity
  currentRevisionId
  licenceType
  orderId
  ${PriceRangeNode}
`;

export const DiscountsNode = `
  uuid
  name
  id
  discounts {
    standard {
      reseller
      distributer
    }
    authorised {
      reseller
      distributer
    }
  }
`;

export const ProductSheetPartNode = `
  id
  uuid
  basePrice
  minimumQuantity
  maximumQuantity
  ${PriceRangeNode}
  part{
    ${PartNode}
  }
`;

export const ProductSheetNode = `
  id
  uuid
  description
  sheetParts {
    edges{
      node {
        ${ProductSheetPartNode}
      }
    }
  }
`;

export const QuoteNode = `
  id
  quotedCompanyName
  authorisedReseller
  licenceType
  auditCreationDate
  lastUpdatedDate
  quotedRetailPrice
  quotedDistributerPrice
  quotedResellerPrice
  quotedCompany{
    id
    name
  }
  company {
    id
    uuid
    name
    companyType
    inheritAuthority
  }
  tier {
    ${DiscountsNode}
  }
  project{
    id
  }
  productSheet{
    id
    uuid
    description
  }
  quotedProducts {
    edges {
      node {
        id
        quoteId
        quotedProductParts {
          edges {
            node {
              id
              partNo
              quantity
              quotedRetailPrice
              quotedDistributerPrice
              quotedResellerPrice
              part {
                ${PartNode}
              }
            }
          }
        }
      }
    }
  }
  existingExpiryDate
  newStartDate
  newExpiryDate
  licence{
    ${LicenceNode}
  }
`;

export const ProjectCloseStatusNode = `
  id
  name
  isSpecial
`;

export const ProjectNode = `
  id
  name
  closeDate
  auditCreationDate
  noOfStreams
  noOfFaces
  notes
  address
  suburb
  city
  state
  country
  postcode
  company {
    ${CompanyInfoNode}
  }
  reseller {
    ${CompanyInfoNode}
  }
  enduser {
    ${CompanyInfoNode}
  }
  outcome
  closeStatus{
    ${ProjectCloseStatusNode}
  }
  closeStatusOther
  actualCloseDate
  quotes{
    edges{
      node{
        id
      }
    }
  }
  licence {
    edges {
      node {
        ${LicenceNode}
      }
    }
  }
`;

export const ProjectCompanyNode = `
  ${CompanyInfoNode}
  children {
    edges {
      node {
        ${CompanyInfoNode}
      }
    }
  }
`;

export const SoftwareVersionNode = `
  id
  versionId
  link
  releaseDate
  releaseNotes
  isCurrent
  isPublic
  isBeta
`;

export const SoftwareNode = `
  id
  uuid
  name
  description
  fileLocation
  orderId
  versions{
    edges{
      node{
        ${SoftwareVersionNode}
      }
    }
  }
`;

export const SoftwareCompanyNode = `
  id
  uuid
  name
  companyType
  users{
    edges{
      node{
        cognitoUuid
        fullName
        id
      }
    }
  }
`;

export const BillingCompanyNode = `
  id
  uuid
  name
  contactName
  contactNumber
  contactEmail
  address
  suburb
  city
  state
  country
  postcode
  notes
  abn
`;

export const BillingProductPartNode = `
  partNo
  name
  price
  count
  summary
`;

export const BillingHistoryNode = `
  id
  uuid
  year
  month
  total
  paidOn
  invoice
`;

export const BillingPartNode = `
  id
  partNo
  name
  basePrice
`;
